var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatutoryCompliance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#B5B510",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5682 21.8185C10.5682 21.2875 11.0004 20.8552 11.5315 20.8552H15.0624V19.5696H13.4635C12.9325 19.5696 12.5002 19.1373 12.5002 18.6063C12.5002 18.0749 12.9325 17.6426 13.4635 17.6426H15.7131V16.357H11.529C10.998 16.357 10.5657 15.9247 10.5657 15.3937C10.5657 14.8627 10.998 14.4304 11.529 14.4304H20.5361C21.7765 14.4304 22.7861 13.4209 22.7861 12.1804C22.7861 10.9399 21.7765 9.93042 20.5361 9.93042H13.4646C12.2241 9.93042 11.2146 10.9399 11.2146 12.1804C11.2146 12.5302 11.3017 12.8575 11.4448 13.1532C10.2444 13.1985 9.27991 14.1824 9.27991 15.3937C9.27991 16.605 10.2441 17.5887 11.4445 17.6342C11.3016 17.9297 11.2146 18.2568 11.2146 18.6065C11.2146 18.9561 11.3016 19.2832 11.4445 19.5785C10.2455 19.6255 9.28237 20.6084 9.28237 21.8189C9.28237 23.059 10.2912 24.068 11.5315 24.068H16.3579V22.7823H11.5315C11.0004 22.782 10.5682 22.3497 10.5682 21.8185ZM13.4646 11.2159H20.5361C21.0678 11.2159 21.5004 11.6485 21.5004 12.1802C21.5004 12.712 21.0678 13.1446 20.5361 13.1446H13.4646C12.9328 13.1446 12.5002 12.712 12.5002 12.1802C12.5002 11.6485 12.9328 11.2159 13.4646 11.2159Z",
    fill: "#B5B510"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.1287C18 22.0798 18.6604 22.8447 19.4706 22.8447H21.1261C21.8305 22.8447 22.4029 22.1779 22.4029 21.3444C22.4029 20.4521 22.0507 20.1285 21.5311 19.9226L18.8806 18.893C18.361 18.6871 18.0088 18.3733 18.0088 17.4712C18.0088 16.6475 18.5812 15.971 19.2857 15.971H20.9411C21.7513 15.971 22.4117 16.7358 22.4117 17.6869",
    stroke: "#B5B510",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.202 15V23.8251",
    stroke: "#B5B510",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutoryCompliance);
export default __webpack_public_path__ + "static/media/StatutoryCompliance.7ad7951bcf18e08e8db3fb844eb1e436.svg";
export { ForwardRef as ReactComponent };